<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Solicitações"
    >
        <BoxEncaminhamento :data="data" />

        <BoxExame :data="data" />

        <BoxProcedimentoCirurgico :data="data" />

        <ModalImpressao ref="ModalImpressao" />

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="$refs.ModalImpressao.open('pos-consulta', data.additionals.atendimentoId)"
                color="info"
            >
                Imprimir
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import BoxEncaminhamento from './encaminhamento/Index'
import BoxExame from './exame/Index'
import BoxProcedimentoCirurgico from './procedimento-cirurgico/Index'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'

export default {
    components: {
        BoxEncaminhamento,
        BoxExame,
        BoxProcedimentoCirurgico,
        ModalImpressao,
    },
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>